{
  "$schema": "../extension_schema.json",
  "name": "flag",
  "enabled": true,
  "contextCharacteristics": [
    {
      "kind": "Capsule",
      "eventTimeRepresentation": "capsule",
      "allowableValues": [false, true],
      "defaultValue": false,
      "proxyKind": "selected"
    },
    {
      "kind": "Condition",
      "eventTimeRepresentation": "investigationTime",
      "allowableValues": [false, true],
      "defaultValue": false,
      "proxyKind": "selected"
    }
  ],
  "uiConfig": {
    "columns": [
      {
        "aggFunc": "LookupAggregator",
        "colDefDefaultValue": false,
        "colDefMinWidth": 110,
        "colDefMaxWidth": 150,
        "colDefName": "Flagged",
        "colDefType": "boolean",
        "colDefFilterType": "set",
        "onClickAction": "toggleState",
        "discreteStates": [
          {
            "testId": "Unflagged",
            "labelTranslationKey": "VANTAGE.EXTENSIONS.FLAG.UNFLAGGED",
            "value": false,
            "icon": "svgpath:M 2.714 1.188 L 2.714 0 L 0 0 L 0 1.188 L 0 2.375 L 0 13.656 L 0 17.813 L 0 19 L 2.714 19 L 2.714 17.813 L 2.714 13.063 L 5.441 12.465 C 7.184 12.083 9.029 12.261 10.637 12.962 C 12.511 13.782 14.687 13.883 16.646 13.237 L 19 12.469 L 19 0.594 L 16.693 1.603 C 14.729 2.464 12.418 2.464 10.454 1.603 C 8.966 0.95 7.256 0.787 5.641 1.139 L 2.714 1.781 L 2.714 1.188 Z",
            "iconFill": "white"
          },
          {
            "testId": "Flagged",
            "labelTranslationKey": "VANTAGE.EXTENSIONS.FLAG.FLAGGED",
            "value": true,
            "icon": "svgpath:M 2.714 1.188 L 2.714 0 L 0 0 L 0 1.188 L 0 2.375 L 0 13.656 L 0 17.813 L 0 19 L 2.714 19 L 2.714 17.813 L 2.714 13.063 L 5.441 12.465 C 7.184 12.083 9.029 12.261 10.637 12.962 C 12.511 13.782 14.687 13.883 16.646 13.237 L 19 12.469 L 19 0.594 L 16.693 1.603 C 14.729 2.464 12.418 2.464 10.454 1.603 C 8.966 0.95 7.256 0.787 5.641 1.139 L 2.714 1.781 L 2.714 1.188 Z",
            "iconFill": "red"
          }
        ]
      }
    ],
    "iconRepresentation": {
      "onClickAction": "toggleState",
      "defaultRepresentation": false,
      "discreteStates": [
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.FLAG.UNFLAG",
          "value": true,
          "icon": "svgpath:M 2.714 1.188 L 2.714 0 L 0 0 L 0 1.188 L 0 2.375 L 0 13.656 L 0 17.813 L 0 19 L 2.714 19 L 2.714 17.813 L 2.714 13.063 L 5.441 12.465 C 7.184 12.083 9.029 12.261 10.637 12.962 C 12.511 13.782 14.687 13.883 16.646 13.237 L 19 12.469 L 19 0.594 L 16.693 1.603 C 14.729 2.464 12.418 2.464 10.454 1.603 C 8.966 0.95 7.256 0.787 5.641 1.139 L 2.714 1.781 L 2.714 1.188 Z",
          "iconFill": "red",
          "nextToggleValue": false,
          "tooltipTemplateTranslationKey": "VANTAGE.EXTENSIONS.FLAG.FLAG_ADDED"
        },
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.FLAG.FLAG",
          "value": false,
          "icon": "svgpath:M 2.714 1.188 L 2.714 0 L 0 0 L 0 1.188 L 0 2.375 L 0 13.656 L 0 17.813 L 0 19 L 2.714 19 L 2.714 17.813 L 2.714 13.063 L 5.441 12.465 C 7.184 12.083 9.029 12.261 10.637 12.962 C 12.511 13.782 14.687 13.883 16.646 13.237 L 19 12.469 L 19 0.594 L 16.693 1.603 C 14.729 2.464 12.418 2.464 10.454 1.603 C 8.966 0.95 7.256 0.787 5.641 1.139 L 2.714 1.781 L 2.714 1.188 Z",
          "iconFill": "white",
          "nextToggleValue": true,
          "tooltipTemplateTranslationKey": "VANTAGE.EXTENSIONS.FLAG.FLAG_REMOVED"
        }
      ],
      "mixedStates": {
        "icon": "svgpath:M 2.714 1.188 L 2.714 0 L 0 0 L 0 1.188 L 0 2.375 L 0 13.656 L 0 17.813 L 0 19 L 2.714 19 L 2.714 17.813 L 2.714 13.063 L 5.441 12.465 C 7.184 12.083 9.029 12.261 10.637 12.962 C 12.511 13.782 14.687 13.883 16.646 13.237 L 19 12.469 L 19 0.594 L 16.693 1.603 C 14.729 2.464 12.418 2.464 10.454 1.603 C 8.966 0.95 7.256 0.787 5.641 1.139 L 2.714 1.781 L 2.714 1.188 Z",
        "nextToggleValue": true,
        "labelTranslationKey": "VANTAGE.EXTENSIONS.FLAG.FLAG"
      }
    },
    "consoleToolbarConfiguration": {
      "sortOrder": 1,
      "onClick": "toggleNextState"
    }
  }
}
